import React, { useEffect } from 'react';

// Material
import Chip from '@mui/material/Chip';

// Components
import AutoComplete from '../Autocomplete';

// Hooks
import useWarehouses from '../../../hooks/warehouse/useWarehouse';

const RenderTags = (value, getTagProps) =>
    value.map((option, index) =>
        <Chip key={index} label={`${option?.name}`} {...getTagProps({ index })} />
    )

const WarehouseAutocomplete = ({ multiple, active = null, onLoad = () => { }, ...rest }) => {
    const { warehouses, loading } = useWarehouses({ isExport: true });
    const warehouseFilter = active != null 
            ? warehouses.filter(w => w.active === active)
            : warehouses
    useEffect(() => {
        if (onLoad && warehouses.length > 0)
            onLoad(warehouses)

        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [warehouses])

    return (
        <AutoComplete
            name='warehouse'
            label={multiple ? 'Depositos' : 'Deposito'}
            placeholder='Ej.: Medrano'
            loadingText='Buscando depositos...'
            disabled={loading || warehouseFilter.length === 0}
            {...rest}
            multiple={multiple}
            options={warehouseFilter}
            getOptionLabel={(option) => option ? `(${option.code || option.id}) ${option.name}` : ''}
            data-testid='warehouses-autocomplete'
            renderTags={RenderTags}
        />
    )
}

export default WarehouseAutocomplete;